import {useCallback, useState} from "react";

/**
 * Custom hook to handle setting snapshot data within 3rd party libraries such as charting libraries where
 * we need (and has support for) handling events with custom data objects needing to be accessed in some sort of
 * temporal order whether by timestamp or index.
 * @returns {{snapshotCallback: function, snapshotData: *[], snapshotDate: *}}
 */
export const useSnapshot = () => {
    const [snapshotData, setSnapshotData] = useState([]);
    const [snapshotDate, setSnapshotDate] = useState(null);

    // Function to handle snapshot updates
    const handleSnapshot = useCallback((point, date) => {
        try {
            const formattedData = Object.entries(point ?? {}).map(([key, value]) => ({
                key: key,
                wgt: value.wgt
            })).sort((a, b) => b.wgt - a.wgt);

            setSnapshotData(formattedData);
            setSnapshotDate(date);
        } catch (error) {
            console.error("Failed to handle snapshot:", error);
        }
    }, []); // Using `useCallback` to prevent unnecessary re-renders

    return {
        snapshotData,
        snapshotCallback: handleSnapshot, // Directly use the callback without debounce/throttle
        snapshotDate
    };
};
